import { useSelector } from "react-redux";
import * as selectors from "src/modules/command/duck/selectors";
import Flow from "src/components/Flow";

import NoCommands from "../scenes/NoCommands";
import CommandEditor from "../scenes/Editor";
import CommandsList from "../scenes/CommandsList";

const steps = [
  {
    id: "commands",
    Component: ({ commands, flow, onClose, onBack }) => {
      let commandsArray = Object.values(commands);

      return commandsArray.length === 0 ? (
        <NoCommands
          onClose={onClose}
          onBack={onBack}
          openEditor={() => flow.push("editor")}
        />
      ) : (
        <CommandsList
          commands={commands}
          onClose={onClose}
          onBack={onBack}
          openEditor={(commandId) =>
            flow.push("editor", { state: { commandId } })
          }
        />
      );
    }
  },
  {
    id: "editor",
    Component: ({ onClose, onBack, flow, initialStep, commands }) => {
      return (
        <CommandEditor
          onClose={onClose}
          onBack={initialStep === "editor" ? onBack : flow.previous}
          command={commands[flow.state.commandId]}
          afterSave={() => flow.push("commands", { direction: "previous" })}
        />
      );
    }
  }
];

export default function CommandsFlow({ initialStep, ...rest }) {
  const commands = useSelector(selectors.getCommands);

  return (
    <Flow
      commands={commands}
      initialStep={initialStep}
      steps={steps}
      {...rest}
    />
  );
}
